module.exports = __webpack_public_path__ + "img/81.a143e558.jpg";